import React, { useContext } from "react";
import QuestionarioSeplag from "../../../../../components/QuestionarioSeplag";
import { AvaliacaoAcaoContext } from "./AvaliacaoAcaoContext";

const AccordionFinanceiro = (props) => {
  const { condicao, camposDispFinan } = useContext(AvaliacaoAcaoContext);
  return (
    <QuestionarioSeplag
      campos={camposDispFinan}
      setCampos={props.setQuestDispFinanAtualizado}
      condicao={condicao}
      IsMaximoCaracteres={true}
      qtdMaxCaracteres={4000}
      isDisabled={!props.podeAvaliarAcao}
    />
  );
};
const AccordionEficiencia = (props) => {
  const { condicao, camposEficiencia } = useContext(AvaliacaoAcaoContext);

  return (
    <QuestionarioSeplag
      campos={camposEficiencia}
      setCampos={props.setCamposQuestionarioEficiencia}
      condicao={condicao}
      IsMaximoCaracteres={true}
      qtdMaxCaracteres={4000}
      isDisabled={!props.podeAvaliarAcao}
    />
  );
};

export { AccordionEficiencia, AccordionFinanceiro };
